import React from 'react';
import { IMAGE_CONSTANT, TEXT_CONSTANT } from '../../constants/app';
import SubscriptionSelector from './SubscriptionSelector';

const SubscriptionPlans = () => {
  const subscriptionPoints = [
    TEXT_CONSTANT.SUBSCRIPTION_POINT_1,
    TEXT_CONSTANT.SUBSCRIPTION_POINT_2,
    TEXT_CONSTANT.SUBSCRIPTION_POINT_3,
  ];
  return (
    <>
      <div className="parent">
        <div className="bg-image"></div>
        <h2 className="mx-auto payment-modal-title">Subscription Plans</h2>
        {subscriptionPoints.map((point, index) => (
          <div className="d-flex texts" key={`subscription-point-${index}`}>
            <div>
              <img
                className=""
                src={IMAGE_CONSTANT.checkboxIcon}
                alt={'check'}
              />
            </div>
            <p className="mb-0 text-start text-white dm-sans">{point}</p>
          </div>
        ))}
      </div>
      <div className="subscription-block__">
        <SubscriptionSelector />
      </div>
    </>
  );
};

export default SubscriptionPlans;
